import * as moment from "moment"
import * as lookup from "../../../../static/lookup.json"
import * as dataLayerLookup from "../../../../static/dataLayerEventTrigger.json"
import { MD5 } from "crypto-js"
import { getAge } from "../../../components/services/helperFunctions"
import { normalizeSpaces } from "../../../shared/functions"
const CryptoJS = require('crypto-js');

export function alphaWealthDataLayer(allJourneyDataResponse, e, sectionId, componentFormControlKey, journeyStateData){
    var allJourneyData = allJourneyDataResponse
    const dateofbirth = allJourneyData?.lifeAssuredDetails?.dob;
    const spouseDateOfBirth = allJourneyData?.spouseDetails?.dob
    const nomineeDateOfBirth = allJourneyData?.nominees?.[0]?.dob
    const emailID = allJourneyData?.lifeAssuredDetails?.communicationDetails?.contactDetails?.emailId?.toLowerCase();
    const mobileNo = allJourneyData?.lifeAssuredDetails?.communicationDetails?.contactDetails?.mobileNo;
    let encryptedEmail  = emailID? MD5(emailID)?.toString() : ''
    let encryptedMobileNo = mobileNo? MD5(mobileNo)?.toString() : ''
    const policyTerm = Number(allJourneyData?.productDetails?.policyTerm) || "";
    const riders = allJourneyData?.productDetails?.riders?.rider
    var optionalBuiltInCoverArray = []
    var optionalBuiltInCover =''
    // let addOnsCalc
    var spouseOptionalBuiltInCoverArray = []
    var spouseOptionalBuiltInCover = ''
    var spouse = allJourneyData?.productDetails?.spouseLaDetails?.wishToSecure === "02" ? "YES" : "NO"
    var PremiumAmount = Number(allJourneyData?.basicDetails?.premium) || Number(allJourneyData?.premium) || "";
    
    const nomineeEmailId = allJourneyData?.nominees?.[0]?.["contactDetails.emailId"] || allJourneyData?.nominees?.[0]?.contactDetails?.emailId
    let spouseCover

    if(allJourneyData?.productDetails?.spouseLaDetails?.wishToSecure === "02"){
        spouseCover = "YES"
    }else if(allJourneyData?.productDetails?.spouseLaDetails?.wishToSecure === "01"){
        spouseCover = "NO"
    }else{
        spouseCover = ""
    }

    const storedDataLayer = JSON.parse(sessionStorage.getItem("dataLayer") || "{}");
    const isResidentDetailsSubmitted = sessionStorage.getItem("isResidentDetailsSubmitted") || false
    const isNomineeDetailsSubmitted = sessionStorage.getItem("isNomineeDetailsSubmitted") || false
    const isPortfolioDetailsSubmitted = sessionStorage.getItem("isPortfolioDetailsSubmitted") || false
    const isCustomiseDetailsSubmitted = sessionStorage.getItem("isCustomiseDetailsSubmitted") || false
    const paymentDataLayer = JSON.parse(sessionStorage.getItem("paymentDataLayer") || "{}")
    const medicalDataLayer = JSON.parse(sessionStorage.getItem("medicalDataLayer") || "{}")

    var dynamicEvent
    var clientId
    try {
      let cookies = document.cookie
      let cookieArray = cookies.split(";")
      if (cookieArray && cookieArray.length) {
          let gaTagCookie = cookieArray.find(element => {
          if (element.includes("_ga=")) {
            return element.split(".")
          }
        })
        if (gaTagCookie) {
            let gaTagCookieSplit = gaTagCookie.split(".")
            if (gaTagCookieSplit && gaTagCookieSplit.length) {
                clientId = `${gaTagCookieSplit[gaTagCookieSplit.length - 2]}.${
                    gaTagCookieSplit[gaTagCookieSplit.length - 1]
                }`
          } else {
            clientId = ""
        }
        } else {
          clientId = ""
        }
    } else {
        clientId = ""
    }
    } catch (err) {
      console.log("Error geting google tag", "err")
    }
    let totalMonthlyPremium 
    var tax = Number(PremiumAmount - Math.round(PremiumAmount/1.18))
    try{
        if(PremiumAmount !== ""){
            if(allJourneyData?.productDetails?.premiumFrequency === "12" ){
                totalMonthlyPremium = Number(PremiumAmount/12)
            }else if(allJourneyData?.productDetails?.premiumFrequency === "01"){
                totalMonthlyPremium = Number(PremiumAmount)
            }else if(allJourneyData?.productDetails?.premiumFrequency === "03"){
                totalMonthlyPremium = Number(PremiumAmount/4)
            }else if(allJourneyData?.productDetails?.premiumFrequency === "06"){
                totalMonthlyPremium = Number(PremiumAmount/6)
            }else if(allJourneyData?.productDetails?.premiumFrequency === "SINGLE PREMIUM"){
                totalMonthlyPremium = Number((PremiumAmount/policyTerm)/12)
            }
        }
        else{
            totalMonthlyPremium = ""
        }
        }catch(err){
        console.log(err,"premium error")
    }
    var monthlyPremium
    var premium
    if(totalMonthlyPremium){
        monthlyPremium = (totalMonthlyPremium - tax)
        premium = (totalMonthlyPremium * 12)
    }else{
        monthlyPremium = ""
        premium = ""
    }
    var userType
    if(allJourneyData?.basicDetails?.existingCustomer){
        userType = allJourneyData?.basicDetails?.existingCustomer === "N" ? "New User" : "Returning User"
    }else{
        userType = ""
    }
    window.dataLayer = window.dataLayer || [];
    let lastDataLayerElement
    if(window.dataLayer.length){
        lastDataLayerElement = window.dataLayer[window.dataLayer.length -1]
    }else{
        lastDataLayerElement = {}
    }

    let paymentMode 
    if(allJourneyData?.transactionDetails?.transactions){
        paymentMode = allJourneyData?.transactionDetails?.transactions[allJourneyData?.transactionDetails?.transactions?.length - 1]?.paymentMethod
    }else{
        paymentMode = journeyStateData?.paymentDecryptData?.paymentMethod
    }

    let paymentOption 
    if(allJourneyData?.basicDetails?.paymentOption){
        if(allJourneyData?.basicDetails?.paymentOption === "N"){
            paymentOption = "paynow"
        }else {
            paymentOption = ""
        }
    }else if(allJourneyData?.paymentStep){
        if(allJourneyData?.paymentStep === "N"){
            paymentOption = "paynow"
        }else {
            paymentOption = ""
        }
    }else{
        paymentOption = ""
    }

    let paymentFrequency
    if(journeyStateData?.lastPage === 0 && journeyStateData?.lastSection > 2){
        paymentFrequency = lookup?.premiumFrequency[0][allJourneyData?.productDetails?.premiumFrequency] || ""
    }else if(journeyStateData?.lastPage > 0){
        paymentFrequency = lookup?.premiumFrequency[0][allJourneyData?.productDetails?.premiumFrequency] || ""
    }else{
        paymentFrequency = ""
    }

    // window.dataLayer = []
    if(e === "previous"){
        dynamicEvent = dataLayerLookup?.alphaWealthPlanJourney?.[sectionId]?.previousButtonEvent?.eventName 
        }else if(e === "proceed"){
            dynamicEvent = dataLayerLookup?.alphaWealthPlanJourney?.[sectionId]?.proceedButtonEvent?.eventName
        }else if(e === "landing"){
            dynamicEvent = dataLayerLookup?.alphaWealthPlanJourney?.[sectionId]?.landingPageEvent?.eventName
        }else {
            console.log(dataLayerLookup)
            dynamicEvent = dataLayerLookup?.alphaWealthPlanJourney?.[sectionId]?.componentKeyEvent?.[componentFormControlKey]?.eventName
        }
        let pageNameHaveSource = window.location.href?.includes("source")
        // if(dynamicEvent === "AW_Buy_PersonalDetail_Landed" && !pageNameHaveSource){
        //     return 
        // }

    const urlParams = new URLSearchParams("?" + window?.location?.href?.split("?")?.[1])
    let sourceParameter
    let gclidParameter
    if(urlParams){
        sourceParameter = urlParams.get("source")
        gclidParameter = urlParams.get("gclid");
    }
    let nomineeRelationship = ''
    if (allJourneyData?.nominees?.[0]?.relationshipWithLa){
        if (allJourneyData?.nominees?.[0]?.gender === "M"){
            nomineeRelationship = lookup?.nomineeRelationshipWithLAMale?.[0][allJourneyData?.nominees?.[0]?.relationshipWithLa]
        }else{
            nomineeRelationship = lookup?.nomineeRelationshipWithLAFemale?.[0][allJourneyData?.nominees?.[0]?.relationshipWithLa]
        }
    }else{
        if (journeyStateData?.nomineeDataSecond?.gender === "M"){
            nomineeRelationship = lookup?.nomineeRelationshipWithLAMale?.[0][journeyStateData?.nomineeDataSecond?.relationship]
        }else if (journeyStateData?.nomineeDataSecond?.gender){
            nomineeRelationship = lookup?.nomineeRelationshipWithLAFemale?.[0][journeyStateData?.nomineeDataSecond?.relationship]
        }
    }

    let nomineeRelationship2 = ''
    if (allJourneyData?.nominees?.[1]?.relationshipWithLa){
        if (allJourneyData?.nominees?.[1]?.gender === "M"){
            nomineeRelationship2 = lookup?.nomineeRelationshipWithLAMale?.[0][allJourneyData?.nominees?.[1]?.relationshipWithLa]
        }else{
            nomineeRelationship2 = lookup?.nomineeRelationshipWithLAFemale?.[0][allJourneyData?.nominees?.[1]?.relationshipWithLa]
        }
    }

    let appointeeDetails = {}
    if (allJourneyData?.nominees?.length > 0){
        for (let i = 0;i<allJourneyData.nominees.length;i++){
            const nominee = allJourneyData.nominees[i]
            if (nominee.appointee){
                appointeeDetails = nominee.appointee
                break;
            }
        }
    }

    const selectedFunds = allJourneyData?.productDetails?.funds?.[0] || []
    const generateLeadId = appNum => {
        if (!appNum) return ""
        const appStr = appNum.toString();
        const prefix = appStr.slice(0, 3); // First 3 digits
        const baseAppNum = Number(prefix + '0000000'); // Dynamic base
        const baseLeadId = 1100000000;
        return (baseLeadId + (Number(appNum) - baseAppNum)).toString().padStart(10, '0');
    };

        if(dynamicEvent){
            const formData = {
                event: dynamicEvent,
                ProductName: "AlphaWealth",
                ProductCategory: "Ulip",
                ProductSubCategory: "",
                ProductCode: allJourneyData?.productDetails?.planOption || "",
                PageType: "Buying Journey",
                // PageName : dataLayerLookup?.alphaWealthPlanJourney?.[sectionId]?.pageName || "",
                PageSection: dataLayerLookup?.alphaWealthPlanJourney?.[sectionId]?.sectionName || "",
                "Policy Type": '',
                SectionName: dataLayerLookup?.alphaWealthPlanJourney?.[sectionId]?.sectionName || "",
                ClientID: clientId,
                LeadID: generateLeadId(allJourneyData?.basicDetails?.applicationNumber || sessionStorage.getItem("appNo")),
                // leadFormType : "",
                Source: sourceParameter ? lookup?.sourceChannelLookup_lowercase?.[0]?.[sourceParameter?.toLowerCase()] : journeyStateData?.channel ? lookup?.sourceChannelLookup_lowercase?.[0][journeyStateData?.channel?.toLowerCase()] : "",
                UserType: journeyStateData?.dedupeResult === true ? "Returning User" : "New User",
                Name: normalizeSpaces(allJourneyData?.lifeAssuredDetails?.fullName) || '',
                MobileNumber: encryptedMobileNo,
                userMob: allJourneyData?.lifeAssuredDetails?.communicationDetails?.contactDetails?.mobileNo ?  CryptoJS.SHA256(`${allJourneyData?.lifeAssuredDetails?.communicationDetails?.contactDetails?.countryCode}${allJourneyData?.lifeAssuredDetails?.communicationDetails?.contactDetails?.mobileNo}`).toString() : '',
                mobile_hash:  allJourneyData?.lifeAssuredDetails?.communicationDetails?.contactDetails?.mobileNo ? btoa(allJourneyData?.lifeAssuredDetails?.communicationDetails?.contactDetails?.mobileNo) : "",
                userEmailId: allJourneyData?.lifeAssuredDetails?.communicationDetails?.contactDetails?.emailId ?  CryptoJS.SHA256(`${allJourneyData?.lifeAssuredDetails?.communicationDetails?.contactDetails?.emailId.toLowerCase()}`).toString() : '',
                emailID_hash:  allJourneyData?.lifeAssuredDetails?.communicationDetails?.contactDetails?.emailId ? btoa(allJourneyData?.lifeAssuredDetails?.communicationDetails?.contactDetails?.emailId?.toLowerCase()) : "",
                EmailID: encryptedEmail,
                Gender: lookup?.gender?.[0][allJourneyData?.lifeAssuredDetails?.gender] || "",
                DOB: dateofbirth ? moment.unix(dateofbirth).format('MM/YYYY') : '',
                Age: dateofbirth ? getAge(dateofbirth) : '',
                City: isResidentDetailsSubmitted ? allJourneyData?.lifeAssuredDetails?.communicationDetails?.currentAddress?.cityDistrict ? allJourneyData?.lifeAssuredDetails?.communicationDetails?.currentAddress?.cityDistrict : '' : "",
                TobaccoConsumer: allJourneyData?.lifeAssuredDetails?.personalDetails?.smoking ? lookup?.["yesNo"][0][allJourneyData?.lifeAssuredDetails?.personalDetails?.smoking] : '',
                Education: allJourneyData?.lifeAssuredDetails?.employmentDetails?.education ? lookup?.["education"]?.[0][allJourneyData?.lifeAssuredDetails?.employmentDetails?.education] : '',
                AnnualIncome: allJourneyData?.lifeAssuredDetails?.employmentDetails?.annualIncome ? Number(allJourneyData?.lifeAssuredDetails?.employmentDetails?.annualIncome) : '',
                AnnualExpense: "",
                AnnualDisposableInc: "",
                ApplicationNumber: allJourneyData?.basicDetails?.applicationNumber ? allJourneyData?.basicDetails?.applicationNumber : '',
                eQuoteNumber: journeyStateData?.illustrationNumber || "",
                SumAssured: allJourneyData?.productDetails?.sumAssured ? allJourneyData?.productDetails?.sumAssured : '',
                "Policy Term": allJourneyData?.productDetails?.policyTerm ? allJourneyData?.productDetails?.policyTerm + " years" :  "",
                Term: allJourneyData?.productDetails?.policyTerm ? allJourneyData?.productDetails?.policyTerm + " years" :  '',
                PremiumPaymentTerm: isCustomiseDetailsSubmitted ? allJourneyData?.productDetails?.premiumPaymentTerm ? allJourneyData?.productDetails?.premiumPaymentTerm + " years" : '' : "",
                PaymentFrequency: isCustomiseDetailsSubmitted ? paymentFrequency || '' : "",
                PremiumOption: "",
                TotalPremium: journeyStateData?.premium ? Number(journeyStateData?.premium) : storedDataLayer?.totalPremium ? Number(storedDataLayer?.totalPremium) : "",
                Premium: journeyStateData?.premium ? Number(journeyStateData?.premium) : storedDataLayer?.premium ? Number(storedDataLayer?.premium) : "",
                MonthlyPremium: monthlyPremium || "",
                TotalMonthlyPremium: totalMonthlyPremium || "",
                Country: lookup?.countryCodeToCountry?.[0][allJourneyData?.lifeAssuredDetails?.communicationDetails?.contactDetails?.countryCodeMap] || "",
                ResidentialStatus: allJourneyData?.lifeAssuredDetails?.residentStatus ? lookup?.["residentStatus"][0][allJourneyData?.lifeAssuredDetails?.residentStatus] : '',
                PinCode: isResidentDetailsSubmitted ? allJourneyData?.lifeAssuredDetails?.communicationDetails?.currentAddress?.pinCode || "" : "",
                State: isResidentDetailsSubmitted ? lookup?.state[0][allJourneyData?.lifeAssuredDetails?.communicationDetails?.currentAddress?.state] || "" : "",
                Occupation: isResidentDetailsSubmitted ? lookup?.occupation?.[0][allJourneyData?.lifeAssuredDetails?.employmentDetails?.occupation] || "" : "",
                NatureOfDuties: isResidentDetailsSubmitted ? lookup?.natureOfOccupation?.[0][allJourneyData?.lifeAssuredDetails?.employmentDetails?.natureOfOccupation] || "" : "",
                ExistingSumAssured: isResidentDetailsSubmitted ? allJourneyData?.lifeAssuredDetails?.existingSumAssured || '' : "",
                "IndianCarRegNo.": isResidentDetailsSubmitted ? allJourneyData?.lifeAssuredDetails?.carRegistration || '' : "",
                PlanOption: isCustomiseDetailsSubmitted ? allJourneyData?.productDetails?.planOption ? lookup.alphaWealthPlanCode[allJourneyData?.productDetails?.planOption] || "" : '' : "",
                CoverageOption: "",
                OptionalBuiltInCover: optionalBuiltInCover || "",
                SettlementOption: "",
                "Life Cover Required": "",
                TimeHorizon: "",
                CapitalProtection: "",
                PrefferedPlan: "",
                Proposer: allJourneyData?.proposerDetails?.fullName ? normalizeSpaces(allJourneyData?.proposerDetails?.fullName) : "",
                ProposerMarritalStatus: allJourneyData?.proposerDetails?.maritalStatus ? (allJourneyData?.proposerDetails?.maritalStatus === "M" ? "Yes" : "No") : "",
                ProposerOccupation: allJourneyData?.proposerDetails?.employmentDetails?.occupation ? lookup?.occupation?.[0][allJourneyData?.proposerDetails?.employmentDetails?.occupation] || "" : "",
                ProposerGender: allJourneyData?.proposerDetails?.["proposerDetails.gender"] ? lookup?.gender?.[0][allJourneyData?.proposerDetails?.["proposerDetails.gender"]] : (allJourneyData?.proposerDetails?.gender ? lookup?.gender?.[0][allJourneyData?.proposerDetails?.gender] : ""),
                ProposerTobacco: "",
                ProposerDOB: allJourneyData?.proposerDetails?.["proposerDetails.dob"] ? moment.unix(allJourneyData?.proposerDetails?.["proposerDetails.dob"]).format('MM/YYYY') : "",
                ProposerCoverageOption: "",
                ProposerSumAssured: "",
                ProposerResidentialStatus: allJourneyData?.proposerDetails?.residentStatus ? lookup?.["residentStatus"][0][allJourneyData?.proposerDetails?.residentStatus] : "",
                ProposerAnnualIncome: allJourneyData?.proposerDetails?.employmentDetails?.annualIncome ? Number(allJourneyData?.proposerDetails?.employmentDetails?.annualIncome) : "",
                ProposerBenefitPayoutOption: "",
                PaymentOption: paymentOption,
                PaymentMode: paymentMode || lastDataLayerElement?.PaymentMode || "",
                NatureOfIndustry: isResidentDetailsSubmitted ? allJourneyData?.lifeAssuredDetails?.employmentDetails?.employerIndustry ? lookup?.["natureOfIndustry"]?.[0][allJourneyData?.lifeAssuredDetails?.employmentDetails?.employerIndustry] : '' : "",
                NomineeDOB: isNomineeDetailsSubmitted ? allJourneyData?.nominees?.[0]?.dob ? moment.unix(allJourneyData?.nominees?.[0]?.dob).format('MM/YYYY') : journeyStateData?.nomineeDataSecond?.dob ? moment.unix(journeyStateData?.nomineeDataSecond?.dob).format('MM/YYYY') : '' : "",
                NomineeRelationship: isNomineeDetailsSubmitted ? nomineeRelationship : "",
                NomineeGender: isNomineeDetailsSubmitted ?  allJourneyData?.nominees?.[0]?.gender ? lookup?.gender?.[0][allJourneyData?.nominees?.[0]?.gender] : journeyStateData?.nomineeDataSecond?.gender ? lookup?.gender?.[0][journeyStateData.nomineeDataSecond.gender] : '' : "",
                NomineeEmail: isNomineeDetailsSubmitted ? allJourneyData?.nominees?.[0]?.["contactDetails.emailId"] ? CryptoJS.MD5(allJourneyData?.nominees?.[0]?.["contactDetails.emailId"]?.toLowerCase())?.toString() : '' : "",
                NomineeMobileNumber: isNomineeDetailsSubmitted ? allJourneyData?.nominees?.[0]?.["contactDetails.mobileNo"] ? CryptoJS.MD5(allJourneyData?.nominees?.[0]?.["contactDetails.mobileNo"]?.toLowerCase())?.toString() : '' : "",
                NomineeMob: isNomineeDetailsSubmitted ? allJourneyData?.nominees?.[0]?.["contactDetails.mobileNo"] ? CryptoJS.MD5(allJourneyData?.nominees?.[0]?.["contactDetails.mobileNo"]?.toLowerCase())?.toString() : '' : "",
                NomineeCount: isNomineeDetailsSubmitted ? allJourneyData?.nominees?.length ? allJourneyData.nominees.length.toString() : "" : "",
                NomineeDOB2: isNomineeDetailsSubmitted ? allJourneyData?.nominees?.[1]?.dob ? moment.unix(allJourneyData?.nominees?.[1]?.dob).format('MM/YYYY') : '' : "",
                NomineeRelationship2: isNomineeDetailsSubmitted ? nomineeRelationship2 : "",
                NomineeGender2: isNomineeDetailsSubmitted ? allJourneyData?.nominees?.[1]?.gender ? lookup?.gender?.[0][allJourneyData?.nominees?.[0]?.gender] : '' : "",
                NomineeEmail2: isNomineeDetailsSubmitted ? allJourneyData?.nominees?.[1]?.["contactDetails.emailId"] ? CryptoJS.MD5(allJourneyData?.nominees?.[1]?.["contactDetails.emailId"]?.toLowerCase())?.toString() : '' : "",
                NomineeMob2: isNomineeDetailsSubmitted ? allJourneyData?.nominees?.[1]?.["contactDetails.mobileNo"] ? CryptoJS.MD5(allJourneyData?.nominees?.[1]?.["contactDetails.mobileNo"]?.toLowerCase())?.toString() : '' : "",
                CounterOffer: "",
                PremiumProtectionCover: "",
                StaffDiscount: "",
                CorporateDiscount: "",
                "StaffDiscount%": "",
                "CorporateDiscount%": "",
                "Identity/AgeProof": isResidentDetailsSubmitted ? storedDataLayer?.proceedWith === "ekyc" ? "e-KYC Verified" : lookup.ID_PROOF[0]?.[allJourneyData?.lifeAssuredDetails?.proofOfIdentity] || '' : "",
                MaritalStatus: allJourneyData?.lifeAssuredDetails?.maritalStatus ?  (allJourneyData?.lifeAssuredDetails?.maritalStatus === "M" ? "Yes" : "No") : '',
                Citizenship: allJourneyData?.lifeAssuredDetails?.citizenship || '',
                // Nationallity: allJourneyData?.lifeAssuredDetails?.nationality || '',
                // BirthCountry: allJourneyData?.lifeAssuredDetails?.countryOfBirth || allJourneyData?.lifeAssuredDetails?.citizenship || '',
                InsuranceRepository: allJourneyData?.lifeAssuredDetails?.amlAddendum?.eInsurance?.insuranceRepository ? lookup?.["insuranceRepository"]?.[0][allJourneyData?.lifeAssuredDetails?.amlAddendum?.eInsurance?.insuranceRepository] : '',
                // IsStaffMember: lookup.yesNo[0][allJourneyData?.lifeAssuredDetails?.employmentDetails?.staff] || '',
                // Nominee : isNomineeDetailsSubmitted ? allJourneyData?.nominees?.length > 0 ? "Yes" : "No" : "",
                APE: journeyStateData?.annualPremiumEquivalent ? Number(journeyStateData?.annualPremiumEquivalent) : storedDataLayer?.annualPremiumEquivalent ? Number(storedDataLayer?.annualPremiumEquivalent) : "",
                KYC: journeyStateData?.proceedWith ? journeyStateData?.proceedWith : storedDataLayer.proceedWith ? lookup.proceedWithMapper[storedDataLayer.proceedWith] : "",
                PartnerName: sourceParameter || (journeyStateData?.channel === "A" ? "HSBC" : journeyStateData?.channel || ""),
                gclid: gclidParameter || "",
                // AppointeeName: appointeeDetails?.fullName || '',
                // AppointeeRelation: lookup.appointeeRelationshipWithNominee[0][appointeeDetails?.relationshipWithNominee] || '',
                // AppointeeDOB: appointeeDetails?.dob ? moment.unix(appointeeDetails.dob).format('MM/YYYY') : '',
                // MedAppointmentCity: "",
                // MedAppointmentDate: medicalDataLayer?.date || "",
                // MedAppointmentTime: medicalDataLayer?.time || "",
                // order_ID: paymentDataLayer?.order_id || "",
                NachStatus: (allJourneyData?.basicDetails?.isPhysicalMandateOpt === true || allJourneyData?.basicDetails?.isPhysicalMandateOpt === "true") ? (allJourneyData?.basicDetails?.nachStatus === true || allJourneyData?.basicDetails?.nachStatus === "true") ? "Success" : "Fail" : (allJourneyData?.basicDetails?.isPhysicalMandateOpt === false || allJourneyData?.basicDetails?.isPhysicalMandateOpt === "false") ? (allJourneyData?.basicDetails?.enachSuccess === true) ? "Success" : "Fail" : paymentDataLayer?.nachStatus || "" ,
                NachType: (allJourneyData?.basicDetails?.isPhysicalMandateOpt === true || allJourneyData?.basicDetails?.isPhysicalMandateOpt === "true") ? "Physical Mandate" : ((allJourneyData?.basicDetails?.isPhysicalMandateOpt === false || allJourneyData?.basicDetails?.isPhysicalMandateOpt === "false") ? "E-Mandate" :  paymentDataLayer?.nachType || ''),
                // MedicalCheckUp: '',
                // SpouseMedicalCheckup: "",
                ReturnOfPremium : "",
                IncomeFrequency : "",
                // OccupationType : "",
                FundCount : isPortfolioDetailsSubmitted ? selectedFunds?.length > 0 ? String(selectedFunds.length) : "" : "",
                FundName : isPortfolioDetailsSubmitted ? selectedFunds?.length > 0 ? selectedFunds.map(item => item.fundName).join(", ") : "" : "",
                SSO : isPortfolioDetailsSubmitted ? allJourneyData?.productDetails?.sso ? lookup.yesNo[0][allJourneyData?.productDetails?.sso ] : "" : "",
                AllocationPercent:  isPortfolioDetailsSubmitted ? selectedFunds?.length > 0 ? selectedFunds.map(item => item.allocationPercent + "%").join(", ") : "" : "",
                "Matuarity Value" : journeyStateData?.titaniumBiKeys?.projectedFundValue4Perc ? String(journeyStateData?.titaniumBiKeys?.projectedFundValue4Perc) : storedDataLayer?.maturityValue ? Number(storedDataLayer?.maturityValue) : "",
                LifeAssured : "",
                DiscountType : "",
                DiscountPercent : "",
                IncomePeriod : "",
                // CoverageAmount :  allJourneyData?.productDetails?.sumAssured ? allJourneyData?.productDetails?.sumAssured : '',
                // BenefitPayoutOption : "",
                // PremiumPaymentOption : "",
                // WholeLifeProtectionOption : "",
                // BenefitPayoutMonthlyInst : "",
                // BenefitPayoutLumpSumPercent : "",
                // SpouseCover : "",
                // SpouseWorking : "",
                SpouseName : "",
                // SpouseGender : "",
                // SpouseTobacco : "",
                // SpouseDOB : "",
                // SpouseSumAssured : "",
                // SpouseBenefitPayoutOption : "",
                // SpouseBenefitPayoutMonthlyInst : "",
                // SpouseRiderSumAssured : "",
                // SpouseBenefitPayoutLumpSumPercent : ""
                SpouseOccupation: "",
                SpouseAnnualIncome: "",
                IsStaffMember: "",
                
            };

            window.dataLayer.push(formData)
        }

}
